import { render } from "./PhaseCustodyResidential.vue?vue&type=template&id=557b6a0a&ts=true"
import script from "./PhaseCustodyResidential.vue?vue&type=script&lang=ts"
export * from "./PhaseCustodyResidential.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__